<template>
  <div
    v-if="isUploadStreamGroupIcon"
    :class="['upload-status-badge', { 'upload-status-active': isActiveStreamGroupIcon }]"
  >
    {{ streamGroup.uploadStatus }}
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { UPLOAD_STATUS_ID_LIST } from '@/composable/constant_common';

const props = defineProps({
  streamGroup: Object,
});

const isUploadStreamGroupIcon = computed(() => {
  const IS_UPLOAD_STATUSES_ID = [
    UPLOAD_STATUS_ID_LIST.UPLOADING,
    UPLOAD_STATUS_ID_LIST.UPLOADED,
    UPLOAD_STATUS_ID_LIST.SCHEDULED,
    UPLOAD_STATUS_ID_LIST.CANCEL,
  ];
  return IS_UPLOAD_STATUSES_ID.includes(props.streamGroup.uploadStatusId);
});

const isActiveStreamGroupIcon = computed(() => {
  const IS_ACTIVE_UPLOAD_STATUSES_ID = [
    UPLOAD_STATUS_ID_LIST.UPLOADED,
    UPLOAD_STATUS_ID_LIST.SCHEDULED,
  ];
  return IS_ACTIVE_UPLOAD_STATUSES_ID.includes(props.streamGroup.uploadStatusId);
});
</script>

<style scoped>
/** アップロードステータス */
.upload-status-badge.upload-status-active {
  margin-top: 1rem;
  bottom: 2rem;
  right: 1.5rem;
  font-size: 1.1rem;
  color: #21963b;
  padding: 5px 10px 5px 10px;
  background-color: #d8f3de;
  border-radius: 2rem;
  width: fit-content;
}
.upload-status-badge {
  margin-top: 1rem;
  bottom: 2rem;
  right: 1.5rem;
  font-size: 1.1rem;
  color: #555555;
  padding: 5px 10px 5px 10px;
  background-color: #eeeeee;
  border-radius: 2rem;
  width: fit-content;
}
</style>
